/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDeliverFeeGradeAmountReqVo
 */
export interface CreateDeliverFeeGradeAmountReqVo {
    /**
     * 用户等级编号
     * @type {number}
     * @memberof CreateDeliverFeeGradeAmountReqVo
     */
    gradeId: number;
    /**
     * 起始金额
     * @type {number}
     * @memberof CreateDeliverFeeGradeAmountReqVo
     */
    startAmount: number;
    /**
     * 步长金额
     * @type {number}
     * @memberof CreateDeliverFeeGradeAmountReqVo
     */
    stepSizeAmount: number;
}

/**
 * Check if a given object implements the CreateDeliverFeeGradeAmountReqVo interface.
 */
export function instanceOfCreateDeliverFeeGradeAmountReqVo(value: object): value is CreateDeliverFeeGradeAmountReqVo {
    if (!('gradeId' in value) || value['gradeId'] === undefined) return false;
    if (!('startAmount' in value) || value['startAmount'] === undefined) return false;
    if (!('stepSizeAmount' in value) || value['stepSizeAmount'] === undefined) return false;
    return true;
}

export function CreateDeliverFeeGradeAmountReqVoFromJSON(json: any): CreateDeliverFeeGradeAmountReqVo {
    return CreateDeliverFeeGradeAmountReqVoFromJSONTyped(json, false);
}

export function CreateDeliverFeeGradeAmountReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeliverFeeGradeAmountReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'],
        'startAmount': json['startAmount'],
        'stepSizeAmount': json['stepSizeAmount'],
    };
}

export function CreateDeliverFeeGradeAmountReqVoToJSON(json: any): CreateDeliverFeeGradeAmountReqVo {
    return CreateDeliverFeeGradeAmountReqVoToJSONTyped(json, false);
}

export function CreateDeliverFeeGradeAmountReqVoToJSONTyped(value?: CreateDeliverFeeGradeAmountReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'startAmount': value['startAmount'],
        'stepSizeAmount': value['stepSizeAmount'],
    };
}

